import { Injectable } from '@angular/core';
import { BranchProvider } from '../analytics/branch';
import { LoggerEvent, LoggerProvider } from '../logger/logger';
import { BranchEventType } from '../../model/types/branch-event-type';

@Injectable()
export class VueBranchProvider {

  constructor(private branchProvider: BranchProvider) {
  }

  async handleBranchEvent(message) {
    try {
      const eventName = message && message.data && message.data.event ? String(message.data.event).trim() : '';
      const traits = message && message.data ? message.data.traits : null;

      if (eventName === BranchEventType.CompleteLoginCreation) {
        this.branchProvider.trackLoginCreation(traits);
        LoggerProvider.info(this, 'Fired Branch event received from bridge', { event: eventName });
        return;
      }

      LoggerProvider.warning(this, LoggerEvent.Vue,
        `Unsupported Branch event received from bridge, not fired. Received '${eventName}'`);
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Vue, 'Failed to fire Branch event received from bridge');
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/vue/vue-branch.ts